// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cf5f9e4e","453":"8cf04052","455":"204ba293","977":"444fcb63"}[chunkId] + ".chunk.js";
};